import React, {useContext} from "react";
import {MANAGE_PROGRAMS_ROUTES, NO_PERMISSION_ERROR, PAGE_HEADERS} from "../util/RouteConstants";
import {Switch} from "react-router-dom";
import TabLayout, {NavigationRoutes} from "../util/TabLayout";
import {injectIntl} from "react-intl"
import PageHeader from "../util/PageHeader";
import Column from "@amzn/meridian/column";
import {useHistory, useLocation} from "react-router-dom";
import ErrorPage from "../error/ErrorPage";
import {PermissionsContext} from "../permissions/PermissionContext";

const ManagePrograms = () => {
    // Checking editor permission
    const {isEditor} = useContext(PermissionsContext);
    if (isEditor === false){
        return <ErrorPage errorTitle="Something went wrong" errorMessage={NO_PERMISSION_ERROR} />;
    }

    const location = useLocation();
    const history = useHistory();

    return (
        <div className="App">
            <Column spacingInset={"small large"}>
                <PageHeader {...PAGE_HEADERS.MANAGE_PROGRAMS}/>
                <TabLayout routes={MANAGE_PROGRAMS_ROUTES} location={location} history={history}/>
                <Switch>
                    <NavigationRoutes routes={MANAGE_PROGRAMS_ROUTES}/>
                </Switch>
            </Column>
        </div>
    )
}

export default injectIntl(ManagePrograms)


// WEBPACK FOOTER //
// ./src/components/manage-programs/ManagePrograms.js